import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { useFormikContext } from 'formik';
import { PubMainTypeEnum } from '../../../types';
/** this function return intial tab index based on the intial form state */
var getInitialTabIndex = function getInitialTabIndex(pubtype) {
  if (pubtype) {
    switch (pubtype.main) {
      case PubMainTypeEnum.PUB_NEWSPAPER:
        return 1;
      case PubMainTypeEnum.PUB_ONLINE:
        return 2;
      case PubMainTypeEnum.PUB_TVR:
        return 3;
      case PubMainTypeEnum.PUB_MAGAZINE:
      default:
        return 0;
    }
  }
  return 0;
};
var getPubTypeMainEnumFromTabIndex = function getPubTypeMainEnumFromTabIndex(index) {
  switch (index) {
    case 1:
      return PubMainTypeEnum.PUB_NEWSPAPER;
    case 2:
      return PubMainTypeEnum.PUB_ONLINE;
    case 3:
      return PubMainTypeEnum.PUB_TVR;
    default:
      return PubMainTypeEnum.PUB_MAGAZINE;
  }
};
var useAdvertisementTabs = function useAdvertisementTabs(_ref) {
  var intialPubtypeState = _ref.intialPubtypeState;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var initialActiveIndex = getInitialTabIndex(intialPubtypeState);
  var _useState = useState(initialActiveIndex),
    _useState2 = _slicedToArray(_useState, 2),
    activeTabIndex = _useState2[0],
    setActiveTabIndex = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    preservedPubtypeStateForTabs = _useState4[0],
    setPreservedPubtypeStateForTabs = _useState4[1];

  /** This will initialize the pubtype state, if not already present */
  useEffect(function () {
    if (!intialPubtypeState) {
      setFieldValue('pubtype', {
        main: PubMainTypeEnum.PUB_MAGAZINE,
        suffix: ''
      });
    }
    setPreservedPubtypeStateForTabs([]);
    setActiveTabIndex(getInitialTabIndex(intialPubtypeState));
  }, [initialActiveIndex, intialPubtypeState]);
  var handleTabChange = function handleTabChange(newActiveTabIndex) {
    /** copying prev state, before any change happens */
    var prevActiveIndex = activeTabIndex;
    var prevMainPubTypeValue = values.pubtype.main;
    var prevSuffixPubTypeValue = values.pubtype.suffix;
    setActiveTabIndex(newActiveTabIndex);
    /** updating formik state with preserved/default value for that tab-index */

    if (preservedPubtypeStateForTabs[newActiveTabIndex]) {
      setFieldValue('pubtype', preservedPubtypeStateForTabs[newActiveTabIndex]);
    } else {
      setFieldValue('pubtype', {
        main: getPubTypeMainEnumFromTabIndex(newActiveTabIndex),
        suffix: ''
      });
    }
    /** preserving prev state */
    setPreservedPubtypeStateForTabs(function (state) {
      state[prevActiveIndex] = {
        main: prevMainPubTypeValue,
        suffix: prevSuffixPubTypeValue
      };
      return state;
    });
  };
  return {
    activeTabIndex: activeTabIndex,
    handleTabChange: handleTabChange
  };
};
export default useAdvertisementTabs;